import { getDefaultLocaleOptions } from "../get-default-options/get-default-options.js";
import { DateTimeFormat } from "../intl-date-time/date-time-format.js";
import { getLocale, getVerifiedDate } from "../shared-utils.js";
/**
 * Format Date
 * @param {Date | number} date dateTime object or timestamp, defaults to now if not set
 * @param {string} locale country code, BCP 47 language string, or array of either - default to 'en-US' if not set
 * @param {BetterDateTimeFormatOptions} options standard dateTimeFormat options object or default options from this package
 *  reference at https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @returns {string}
 * @deprecated Use polyfill solution instead (see README.md)
 * ```js
 * import "@tesla/intl-date-time/polyfill.js";
 *
 * const date = new Date(Date.UTC(2020, 11, 20, 3, 23, 16, 738));
 * const formatter = new Intl.DateTimeFormat("en-US", { dateStyle: "short" });
 * const output = formatter.format(date);
 * expect(result).toEqual("12/19/20");
 * ```
 */
export const formatDate = (date, locale, options) => {
    // ensure we have a locale
    const newLocale = getLocale(locale);
    // check if any locale-specific options
    const newOptions = {
        ...getDefaultLocaleOptions("date", newLocale),
        ...options,
    };
    return new DateTimeFormat(newLocale, newOptions).format(getVerifiedDate(date));
};
